// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"636":"618866bc","754":"41ac9bad"}[chunkId] + ".chunk.css";
};